
import {
   GETCANDIDATE,
 
} from "../actions/type";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // Setup partyTypeList Cases
    case GETCANDIDATE:
      return {
        ...state,
        getcandidate: action.payload,
      };
    
    default:
      return state;
  }
}